import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';
import { Link as RouterLink } from 'react-router-dom';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${props => props.theme.backgroundColor};
  cursor: default;
`;

export const Container = styled.div`
  padding: ${props => props.theme.padding.default};
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 295px;
  margin: ${props => props.theme.margin.default};
`;

export const CalendarTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: ${props => props.theme.margin.default};
`;

export const ArrowButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-size: ${props => `${props.theme.fontSize.default}rem`};

  &:hover {
    opacity: 0.8;
  }

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const MonthYear = styled.div`
  text-transform: uppercase;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  line-height: 1;

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const DayNamesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  max-width: 350px;
  margin: ${props => props.theme.margin.default};
`;

export const DayName = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  line-height: 1;
  margin: 0 auto;
  text-align: center;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: ${props => props.theme.rowGap};
  column-gap: ${props => props.theme.columnGap};
  width: 100%;
  max-width: 350px;
`;

export const Day = styled.div`
  min-width: ${props => props.theme.width.default};
  max-width: ${props => props.theme.width.default};
  padding: ${props => props.theme.padding.default};
  margin: 0 auto;
  text-align: center;
  background-color: ${props =>
    props.selected
      ? props.theme.backgroundColor.selected
      : props.clickable
      ? props.theme.backgroundColor.clickable
      : props.weekend
      ? props.theme.backgroundColor.weekend
      : props.theme.backgroundColor.default};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  line-height: 1;
  cursor: ${props => props.clickable && 'pointer'};

  &:hover {
    background-color: ${props =>
      props.clickable && props.theme.backgroundColor.hover};
  }

  &:first-child {
    grid-column-start: ${props => props.startColumn};
  }

  ${Media.sm`
    min-width: ${props => props.theme.width.sm};
    max-width: ${props => props.theme.width.sm};
    padding: ${props => props.theme.padding.sm};
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Event = styled(RouterLink)`
  position: relative;
  width: 100%;
  min-height: 80px;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  text-decoration: none;
  &:hover {
    color: ${props => props.theme.color || 'inherit'};
  }
  &:after {
    position: absolute;
    content: '${props => (props.theme.after ? props.theme.after.content : '')}';
    top: 50%;
    right: 7px;
    transform: rotate(270deg);
    transform-origin: top;
    transition: 0.2s all;
    background-color: ${props => props.theme.after.backgroundColor};
    color: ${props => props.theme.after.color};
    font-family: ${props => props.theme.after.fontFamily};
    font-size: ${props => `${props.theme.after.fontSize}rem`};
    line-height: ${props => props.theme.after.lineHeight};
    font-weight: ${props => props.theme.after.fontWeight};
    padding: ${props => props.theme.after.padding};
  }

  &:hover:after {
    background-color: ${props => props.theme.after.backgroundColorOnHover};
  }

    ${Media.sm`
      padding: ${props => props.theme.padding.sm};
      &:after {
        right: 0;
        font-size: ${props => `${props.theme.after.fontSizeSm}rem`};
        padding: ${props => props.theme.after.paddingSm};
      }
    `}
`;

export const Title = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
  margin: ${props => props.theme.margin.default};
`;

export const Text = styled.div`
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};
`;

export const Link = styled(RouterLink)`
  background-color: ${props => props.theme.backgroundColor.default};
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize}rem`};
  font-weight: ${props => props.theme.fontWeight};
  font-family: ${props => props.theme.fontFamily};

  &:hover {
    background-color: ${props => props.theme.backgroundColor.hover};
    color: ${props => props.theme.color};
  }

  ${Media.sm`
    padding: ${props => props.theme.padding.sm};
  `}
`;
